export const GoatedGoatsEnvironment = {
  mainnet: {
    "GoatedGoats":"0x2068315349bdfce5",
    "GoatedGoatsTrait":"0x2068315349bdfce5",
  },
};